import { Col, Container, Row } from "react-bootstrap";
import classes from "./styles.module.scss";
import clsx from "classnames";
import { DynamicText } from "@/components/DynamicText";
// import Lottie from "lottie-react";
import dynamic from "next/dynamic";
const DynamicLottie = dynamic(() => import("lottie-react"), { ssr: false });
import { useMediaQuery } from "@react-hook/media-query";
import { useEffect, useMemo, useRef, useState } from "react";

export const GenericBanner = ({ className, title, subTitle, children, animationData, loop, style }) => {
  const lottieRef = useRef();
  const [line1Width, setLine1Width] = useState();
  const [line2Width, setLine2Width] = useState();
  const lg = useMediaQuery("only screen and (min-width: 992px)");
  // const [showAnim, setShowAnim] = useState(false);

  useEffect(() => {
    const handler = () => {
      const rect = lottieRef?.current?.getBoundingClientRect();

      setLine1Width(rect ? rect.x : "initial");
      setLine2Width(rect ? `calc(100% - ${rect.x + rect.width}px)` : "initial");
    };

    if (window) {
      window.addEventListener("resize", handler);
    }

    handler();

    return () => {
      window.removeEventListener("resize", handler);
    };
  });

  // useEffect(() => {
  //   setShowAnim(lg);
  // }, [lg]);

  return (
    <div className={clsx(className, classes.banner)} style={style}>
      <div className={clsx(classes.banner__content)}>
        <Container fluid="lg">
          <Row className="pt-4 pt-md-5 z-3">
            <Col xs={12} md={10} xl={10}>
              <h1 className="py-4 pt-md-0 mb-md-0">
                {typeof title === "object" && "path" in title ? (
                  <DynamicText path={title.path} dangerouslySetInnerHTML={{ __html: title.placeholder }} />
                ) : (
                  <span dangerouslySetInnerHTML={{ __html: title }} />
                )}
              </h1>
              <p className="py-4 pt-md-0 mb-md-0 z-2 w-75">
                {typeof subTitle === "object" && "path" in subTitle ? (
                  <DynamicText path={subTitle.path} dangerouslySetInnerHTML={{ __html: subTitle.placeholder }} />
                ) : (
                  <span dangerouslySetInnerHTML={{ __html: subTitle }} />
                )}
              </p>
              {children}
            </Col>
          </Row>
        </Container>
      </div>
      {animationData && (
        <div className={classes.banner__animation}>
          <Container fluid="xl" className="d-flex align-items-end justify-content-end">
         
            <div ref={lottieRef} className={classes.banner__animation__lottie}>
              <DynamicLottie
                rendererSettings={{
                  preserveAspectRatio: "xMidYMid meet",
                  progressiveLoad: true,
                }}
                animationData={animationData}
                loop={loop}
              />
            </div>
       
          </Container>
        </div>
      )}
    </div>
  );
};

GenericBanner.defaultProps = {
  animationData: null,
  loop: false,
  fallbackImage: null,
};
